import { render, staticRenderFns } from "./NotificationCount.vue?vue&type=template&id=07f1a296&scoped=true&"
import script from "./NotificationCount.vue?vue&type=script&lang=js&"
export * from "./NotificationCount.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCount.vue?vue&type=style&index=0&id=07f1a296&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f1a296",
  null
  
)

export default component.exports